export default __webpack_public_path__ + "static/media/qr-big.9e2ba374.png";